<template>
  <transition name="fade" mode="out-in">
    <div v-if="visible" class="small-modal" @click.self="hide(false)">
        <div class="modal-container">
            <div class="card-header">
                <h4>Ändra deadline för markerade artiklar</h4>
            </div>
            <div class="card-body bg-white">
                <div class="form-group col-sm-12">
                    <label>{{ $t('deadline') }}</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <fa :icon="['fal','calendar-alt']" />
                            </span>
                        </div>
                        <date-picker v-model="deadline" :config="dpConfig"/>
                    </div>
                </div>
                <p class="text-danger px-3">OBS! Deadline kommer ändras för samtliga markerade artiklar!</p>
            </div>
            <div class="card-footer text-right">
                <button class="btn text-danger" @click="hide(false)" >Avbryt</button>
                <button class="btn btn-success" @click="saveDeadline">Spara</button>
            </div>
        </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";

export default {
    props: [
        'printableIds',
        'deadlineModal'
    ],

    data() {
        return {
            deadline: '',
            errors: [],
            visible: false,
            dpConfig: {
              format: 'YYYY-MM-DD',
              useCurrent: false,
              locale : 'sv',
            }
        }
    },

    watch: {
        deadlineModal (n,o) {
            if (this.deadlineModal && !this.visible) this.show()
            else if (!this.deadlineModal && this.visible) this.hide(false)
        },
    },

    methods: {
        hide(reload) {
            this.visible = false;
            this.$emit('modal', reload);
        },
        show() {
            this.visible = true;
        },
        async saveDeadline() {
            let params = {
                printable_ids: this.printableIds,
                deadline: this.deadline,
            }

            const { data } = await axios.post('/api/printable/deadline',params);
            this.hide(true);
        },
    },


}
</script>

<style>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/EditDeadlineModal.vue